// Canguro brand: amarillo canguro
const canguroYellow = '#F5D61B';
const canguroYellowDark = '#D4B800';
const canguroYellowLight = '#FFE566';
const canguroBlack = '#1A1A1A';

export const light = {
  alternate: {
    main: '#FFFBE6',
    dark: '#FFF3BF',
  },
  cardShadow: 'rgba(245, 214, 27, .25)',
  mode: 'light',
  primary: {
    main: canguroYellow,
    light: canguroYellowLight,
    dark: canguroYellowDark,
    contrastText: canguroBlack,
  },
  secondary: {
    main: canguroBlack,
    light: '#333333',
    dark: '#000000',
    contrastText: '#fff',
  },
  text: {
    primary: '#2d3748',
    secondary: '#646e73',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#fff',
    default: '#fff',
    level2: '#f5f5f5',
    level1: '#fff',
  },
};

export const dark = {
  alternate: {
    main: '#2a2608',
    dark: '#1f1c06',
  },
  cardShadow: 'rgba(0, 0, 0, .2)',
  common: {
    black: '#000',
    white: '#fff',
  },
  mode: 'dark',
  primary: {
    main: canguroYellow,
    light: canguroYellowLight,
    dark: canguroYellowDark,
    contrastText: canguroBlack,
  },
  secondary: {
    main: '#EEEEEF',
    light: '#fff',
    dark: '#AEB0B4',
    contrastText: canguroBlack,
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#AEB0B4',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#1a1a1a',
    default: '#1a1a1a',
    level2: '#242424',
    level1: '#2D3748',
  },
};
